import { MarketplaceItem } from "../../../../../common/api/decimal/methods/product.ts";
import { clsx } from "clsx";
import { FormattedMessage, FormattedNumber } from "react-intl";
import styles from "./MarketplaceRadioButton.module.scss";
import { SingleSpaceLiteral } from "../../../../../common/core-ui/SingleSpaceLiteral.tsx";
import { ReactNode } from "react";

const currency = "USD";

function LineItem({
  name,
  value,
  lineBreak,
}: {
  name: ReactNode;
  value: ReactNode;
  lineBreak?: boolean;
}) {
  return (
    <span className={clsx(styles.lineItem, lineBreak && styles.lineBreak)}>
      <strong>{name}</strong>
      <SingleSpaceLiteral />
      <span>{value}</span>
    </span>
  );
}

export default function MarketplaceRadioButton({
  item,
  defaultChecked,
  disabled,
}: {
  item: MarketplaceItem;
  defaultChecked: boolean;
  disabled: boolean;
}) {
  return (
    <label
      className={clsx(
        "vst-radio-check",
        "vst-radio-check-option-no-border",
        "vst-radio-check-option-radio-checkmark",
        styles.radioButtonBox
      )}
    >
      <input
        type="radio"
        name="productId"
        defaultChecked={defaultChecked}
        value={item.productId}
        disabled={disabled}
      />
      <span className={styles.labelContents}>
        <span className={styles.titleRow}>
          <span className={styles.condition}>
            <FormattedMessage defaultMessage="Condition:" tagName="span" />
            <SingleSpaceLiteral />
            {item.condition.replace("marketplace - ", "")}
          </span>
          <span className={styles.price}>
            <FormattedNumber
              value={parseFloat(item.unitPriceRaw)}
              currency="USD"
              style="currency"
            />
            <SingleSpaceLiteral />
            {currency}
          </span>
        </span>
        <LineItem
          name={<FormattedMessage defaultMessage="Seller Name:" />}
          value={item.sellerName}
        />
        <LineItem
          name={<FormattedMessage defaultMessage="Seller Location:" />}
          value={item.location}
        />
        <LineItem
          name={<FormattedMessage defaultMessage="Description:" />}
          value={item.comments && '"' + item.comments + '"'}
          lineBreak
        />
      </span>
    </label>
  );
}
